<ui-quiz [id]="interface._id"></ui-quiz>
